import React from "react"
import Footer from "../Footer"
import Navbar from "../Navbar"
import ScrollToTop from "../ScrollToTop"

export default function MainLayout(props: { children: React.ReactNode }) {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <ScrollToTop />
      {props.children}
      <Footer />
    </div>
  )
}
